import { useQuery } from "@tanstack/react-query";

import { getShopDiscounts } from "api/methods";
import type { Models } from "api/types";

export const shopDiscountsQuery = () => ({ ...getShopDiscounts.keyed(), staleTime: 1000 * 10 });

/**
 * The patient's discounts (`GET /shop/discounts`). It does not block the page: cards render at once and badges,
 * custom colours and the "On sale" option fill in when this arrives.
 */
export const useShopDiscounts = (): Models<"ShopDiscountModel"> | undefined =>
  useQuery(shopDiscountsQuery()).data;
